function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';

import { faArrowCircleRight as falArrowCircleRight, faEnvelope as falEnvelope, faBook as falBook, faGlobe as falGlobe } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-light-svg-icons';

import { faCheckCircle as fasCheckCircle, faCookieBite as fasCookieBite, faEnvelope as fasEnvelope, faGlobe as fasGlobe, faFile as fasFile, faPuzzlePiece as fasPuzzlePiece, faServer as fasServer, faPlay as fasPlay, faExchange as fasExchange, faCalculator as fasCalculator, faWrench as fasWrench } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-solid-svg-icons';

import { faTwitter, faFacebook, faInstagram } from '@epi/font-awesome-pro/js-packages/@fortawesome/pro-brands-svg-icons';

import IconBase from './IconBase';

import './WebsiteIcon.css';

var WebsiteIcon = function (_Component) {
  _inherits(WebsiteIcon, _Component);

  function WebsiteIcon() {
    _classCallCheck(this, WebsiteIcon);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  WebsiteIcon.prototype.componentDidMount = function componentDidMount() {};

  WebsiteIcon.prototype.getClassName = function getClassName() {
    var defaultClassName = 'Icon WebsiteIcon';
    if (this.props.className) {
      return defaultClassName + ' ' + this.props.className;
    }
    return defaultClassName;
  };

  WebsiteIcon.prototype.render = function render() {
    return React.createElement(
      'span',
      { className: this.getClassName() },
      React.createElement(IconBase, this.props)
    );
  };

  return WebsiteIcon;
}(Component);

WebsiteIcon.init = function () {
  if (WebsiteIcon.initialised) {
    return;
  }

  library.add(falArrowCircleRight, falEnvelope, falBook, falGlobe, fasCheckCircle, fasCookieBite, fasEnvelope, fasGlobe, fasFile, fasPuzzlePiece, fasServer, fasPlay, fasExchange, fasCalculator, fasWrench, faTwitter, faFacebook, faInstagram);

  WebsiteIcon.initialised = true;
};

WebsiteIcon.init();

export default WebsiteIcon;